import React from 'react';
import { Theme, makeStyles, createStyles, AppBar, IconButton, Toolbar, Typography, Button, ThemeProvider, createMuiTheme } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

interface Props {
  handleClose: () => void,
  title: string | React.ReactNode,
  titleLabel?: string,
  isSmall?: boolean
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    appBar: {
      position: 'relative',
      minHeight: '60px',
    },
    appBarSmall: {
      position: 'relative',
      minHeight: '30px',
      display: 'flex',
      alignItems: 'flex-end',
    },
    title: {
      marginLeft: theme.spacing(2),
      flex: 1,
      fontSize: '1.5rem',
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1)
    }
  }),
);

const theme = createMuiTheme({
  overrides: {
    MuiAppBar: {
      colorPrimary: {
        color: '#fff',
        backgroundColor: '#002596',
        boxShadow: 'none'
      }
    },
    MuiToolbar: {
      regular: {
        minHeight: '30px !important',
      },
    },
  }
});

const ModalHeader: React.FC<Props> = (props: Props) => {
  const classes = useStyles();
  const titleLabel: string = props.titleLabel ? props.titleLabel : 'title';
  return (
    props.isSmall?
      <ThemeProvider theme={theme}>
        <AppBar className={classes.appBarSmall}>
          <Toolbar>
            <Button color="inherit" onClick={props.handleClose} aria-label="close">
              <Typography component="span">閉じる</Typography>
            </Button>
          </Toolbar>
        </AppBar>
      </ThemeProvider>
      :
      <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton edge="start" color="inherit" onClick={props.handleClose} aria-label="close">
              <CloseIcon />
            </IconButton>
            <Typography variant="h1" className={classes.title} aria-label={titleLabel}>
              {props.title}
            </Typography>
          </Toolbar>
      </AppBar>
  )
}

export default ModalHeader;
